/* eslint-disable @typescript-eslint/camelcase */

import { FcsFlag } from "../unleash";

const FcsFlagsCodConfiguration = {
  permission_redirect_cod_international_configuration_edit: new FcsFlag.Flag(
    false
  )
};

export const FlagsCodConfiguration = {
  ...FcsFlagsCodConfiguration
};

export function initFlagsCodConfiguration() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureCodConfiguration", FcsFlagsCodConfiguration);
}
